// mock-api.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpInterceptorFn,
} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { mockData } from './ mockData';

export const MockApiInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.endsWith('/users/me/customers')) {
    // Combine the three numeric columns into one grouped column object per row.
    // The grouped column name matches the schema: "Group Column Test".
    mockData.data.rows = mockData.data.rows.map((row: any) => {
      const grouped = {
        targetedFrequency: row.targetedFrequency ?? 0,
        visits: row.visits ?? 0,
        calls: row.calls ?? 0,
      };

      // Create a shallow copy, remove original fields and add the grouped object
      const newRow = { ...row };
      delete newRow.targetedFrequency;
      delete newRow.visits;
      delete newRow.calls;

      // Use the exact schema name for the grouped column
      newRow['GroupColumnTest'] = grouped;

      return newRow;
    });

    // console.log(mockData);

    return of(new HttpResponse({ status: 200, body: mockData })).pipe(
      delay(1000)
    );
  }

  // Pass through others
  return next(req);
};
